import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["badgeProps", "children", "disabled", "endIcon", "fullWidth", "loading", "loadingIconOnly", "loadingLabel", "showBadge", "size", "startIcon", "statusBadge", "statusBadgeProps", "variant"];
import React, { forwardRef } from 'react';
import MuiButton from '@mui/material/Button';
import { Badge } from '../Badge';
import { useTheme } from '@mui/system';
import { LoadingIndicator } from '../LoadingIndicator';
import { LoadingButton } from './internal/LoadingButton';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var Button = /*#__PURE__*/forwardRef(function Button(props, ref) {
  var badgeProps = props.badgeProps,
    children = props.children,
    controlledDisabled = props.disabled,
    endIcon = props.endIcon,
    fullWidth = props.fullWidth,
    _props$loading = props.loading,
    loading = _props$loading === void 0 ? false : _props$loading,
    _props$loadingIconOnl = props.loadingIconOnly,
    loadingIconOnly = _props$loadingIconOnl === void 0 ? false : _props$loadingIconOnl,
    loadingLabel = props.loadingLabel,
    _props$showBadge = props.showBadge,
    showBadge = _props$showBadge === void 0 ? false : _props$showBadge,
    size = props.size,
    startIcon = props.startIcon,
    _props$statusBadge = props.statusBadge,
    statusBadge = _props$statusBadge === void 0 ? false : _props$statusBadge,
    statusBadgeProps = props.statusBadgeProps,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'primary' : _props$variant,
    other = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var disabled = controlledDisabled || loading || loadingIconOnly;
  var getLoaderColor = function getLoaderColor(variant) {
    switch (variant) {
      case 'primary':
      case 'primary-destructive':
        return theme.palette.common.white;
      case 'secondary-gray':
        return theme.palette.gray[700];
      case 'secondary-gray-destructive':
        return theme.palette.error[700];
      case 'secondary':
        return theme.palette.primary[600];
      case 'secondary-destructive':
        return theme.palette.error[600];
      default:
        return theme.palette.gray[500];
    }
  };
  var loadingSpinnerProps = {
    backgroundColor: theme.palette.gray[200],
    color: getLoaderColor(variant),
    loadingStyle: 'line-spinner',
    spinnerSize: 20,
    value: 30
  };
  return (loading || loadingIconOnly) && (variant.includes('primary') || variant.includes('secondary')) ? /*#__PURE__*/_jsx(MuiButton, _extends({
    className: loadingIconOnly ? 'loading-iconOnly' : 'loading',
    endIcon: null,
    fullWidth: fullWidth,
    ref: ref,
    size: size,
    startIcon: !loadingIconOnly && loadingLabel ? /*#__PURE__*/_jsx(LoadingIndicator, _extends({}, loadingSpinnerProps)) : undefined,
    sx: {
      '& .MuiButton-startIcon': {
        marginRight: children === undefined || children === '' || children === null ? '0px' : '8px'
      },
      whiteSpace: 'nowrap',
      width: fullWidth ? '100%' : 'fit-content'
    },
    variant: variant
  }, other, {
    children: loadingIconOnly ? /*#__PURE__*/_jsx(LoadingIndicator, _extends({}, loadingSpinnerProps)) : /*#__PURE__*/_jsx(LoadingButton, {
      children: children,
      loadingLabel: loadingLabel,
      loadingSpinnerProps: loadingSpinnerProps
    })
  })) : /*#__PURE__*/_jsxs(MuiButton, _extends({
    disabled: disabled,
    endIcon: endIcon,
    fullWidth: fullWidth,
    ref: ref,
    size: size,
    startIcon: startIcon,
    sx: {
      whiteSpace: 'nowrap',
      width: fullWidth ? '100%' : 'fit-content'
    },
    variant: variant
  }, other, {
    children: [children, showBadge ? /*#__PURE__*/_jsx(Badge, _extends({
      color: "primary",
      size: "sm",
      sx: _extends({
        ml: size === 'xxl' ? theme.spacing(3) : theme.spacing(2)
      }, (size === 'small' || size === 'medium') && {
        height: '20px'
      }),
      type: "pillColor"
    }, badgeProps)) : statusBadge && /*#__PURE__*/_jsx(Badge, _extends({
      color: "primary",
      sx: {
        '.MuiChip-label': {
          paddingLeft: '16px',
          paddingRight: '22px'
        },
        height: '16px',
        position: 'absolute',
        right: '-3px',
        top: '-3px',
        width: '16px'
      },
      type: "pillColor"
    }, statusBadgeProps))]
  }));
});